import {
  LocaleLanguages,
  localeLanguagesSchema,
} from "@boark/shared/types/locale-languages";
import {
  getValueAtPathFromLocale,
  LocaleOptions,
} from "@boark/shared/utils/locale";
import { create } from "zustand";

import en from "../locale/en";
import { Locale } from "../locale/locale.type";
import sv from "../locale/sv";
import { getItem, setItem } from "../services/local-storage";

const locales: { en: Locale; sv: Locale } = {
  en,
  sv,
};

export type LocalRef = string;

export const useLocale = create<{
  locale: Locale;
  currentLanguage: LocaleLanguages;
  setLocale: (locale: string) => void;
  get: (path: string, options?: LocaleOptions) => string;
}>((set, get) => {
  const currentLanguage = getItem<LocaleLanguages>(
    "current-language",
    localeLanguagesSchema,
    "sv",
  );

  return {
    locale: locales[currentLanguage],
    currentLanguage,
    setLocale: (locale: LocaleLanguages) => {
      setItem("current-language", locale);
      set({ currentLanguage: locale, locale: locales[locale] });
    },
    get: (path: string, options: LocaleOptions = {}) => {
      const { currentLanguage } = get();
      return getValueAtPathFromLocale(locales[currentLanguage], path, options);
    },
  };
});
